module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-13.2181237b.png";